{
  "frozen-columns-onboarding.spotlight.body": "Ordene, congele e redimensione tickets com um único controle.",
  "frozen-columns-onboarding.spotlight.dismiss": "OK",
  "frozen-columns-onboarding.spotlight.heading": "Gerencie tickets",
  "jira-nin-group-by-any-field-changeboarding.spotlight.body": "Agrupe tickets por campos, incluindo versões, etiquetas, tipos de ticket e muito mais.",
  "jira-nin-group-by-any-field-changeboarding.spotlight.dismiss": "OK",
  "jira-nin-group-by-any-field-changeboarding.spotlight.heading": "Agrupe tickets para se manter organizado"
}